import MainSlider from 'rc-slider';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import 'rc-slider/assets/index.css';
import { SelectPicker } from '@/components/Elements';
import customTheme from '@/customTheme.json';

export const SliderStyledWrap = styled.div`
  .rc-slider-mark-text {
    font-family: var(--md-secondary-fonts-stack);
    font-size: 14px;
    top: -65px;
  }
  .rc-slider-mark-text .step--selected {
    background-color: var(--md-yellow-color);
    border-radius: 5px;
    padding: 5px 18px;
    margin-top: -20px;
  }
  .rc-slider-mark-text .step--selected:after {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid var(--md-yellow-color);
    bottom: -8px;
    content: ' ';
    height: 0;
    left: calc(50% - 8px);
    position: absolute;
    width: 0;
  }
  .rc-slider-mark-text .step--selected span {
    color: white;
    display: block;
  }
  .rc-slider-dot-active {
    /* Don't move! It doesn't work on the styled component. Why? No idea... */
    background-color: var(--md-yellow-color) !important;
  }
`;

export type SliderProps = {
  min?: number;
  max: number;
  step?: number;
  onSliderChange: (step?: any) => void;
  defaultValue?: number;
  marks: any;
  selectMarks: any;
  className?: string;
  selectClass?: string;
};

export const Slider = ({
  min = 0,
  max,
  step = 1,
  onSliderChange,
  defaultValue = 0,
  marks = {},
  selectMarks = {},
  className = '',
  selectClass = '',
}: SliderProps) => {
  const { t } = useTranslation();

  const getDataForSelect = () =>
    Object.entries(selectMarks).map((key) => ({
      label: `${t('common.upTo')} ${t(`productSteps.${key[1]}`)}`,
      value: key[0],
    }));

  return (
    <SliderStyledWrap>
      <div className={`${selectClass} block lg:hidden`}>
        <SelectPicker
          data={getDataForSelect()}
          onChange={onSliderChange}
          className="z-30 w-full"
          placeholder={t('productSteps.select')}
        />
      </div>
      <MainSlider
        min={min}
        max={max}
        step={step}
        onChange={onSliderChange}
        defaultValue={defaultValue}
        className={`${className} hidden lg:block`}
        trackStyle={{
          backgroundColor: customTheme.colors['md-yellow'],
          height: 3,
        }}
        handleStyle={{
          borderColor: customTheme.colors['md-yellow'],
          height: 16,
          width: 16,
          marginLeft: -1,
          marginTop: -7,
          backgroundColor: 'white',
          opacity: 1,
          borderWidth: 3,
          boxShadow: 'none',
        }}
        railStyle={{
          backgroundColor: customTheme.colors['md-yellowAlt2'],
          height: 3,
        }}
        dotStyle={{
          borderColor: customTheme.colors['md-yellowAlt2'],
          backgroundColor: customTheme.colors['md-yellowAlt2'],
          height: 12,
          width: 12,
          top: -5,
        }}
        activeDotStyle={{
          borderColor: customTheme.colors['md-yellow'],
          backgroundColor: customTheme.colors['md-yellow'],
        }}
        dots
        marks={marks}
      />
    </SliderStyledWrap>
  );
};
